import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { SCol, SRow } from '@avalara/skylab-sdk/react';
import { setProgressBarCurrentStep } from '@avalara/bat-apps-shared/client/actions/progress-bar';
import { FormContainer } from '../styled/forms';
import FormInput from '../../../containers/shared/forms/form-input';
import FormSelect from '../../../containers/shared/forms/form-select';
import { setAdditionalRequiredFields } from '../../../store/shared-signup';
import { goToNextOfferStep } from '../../../lib/side-effects/offer-flow';
import { stepNames } from '../../../lib/side-effects/progress-bar';
import { isFormIncomplete } from '../../../lib/shared-signup';
import { selectState } from '../../../selectors';
import { isEmbeddedSelector } from '../../../selectors/offer';
import { useFetchRegionsAndCountries } from '../../shared/hooks';
import { setCurrentOfferPage } from '../../../store/offer';
import SignInLink from '../sign-in-link';
import { Pages } from '../../../../shared/types/offers';
const Company = ({ flow, shouldFetchRegionsAndCountries }) => {
    const dispatch = useDispatch();
    const isEmbedded = useSelector(isEmbeddedSelector);
    const history = useHistory();
    const { offer: { allowedUsers, offerFlow }, sharedSignup, } = useSelector(selectState);
    const emeaCompanyField = 'emeaCompanyType';
    const disabled = isFormIncomplete(sharedSignup);
    useEffect(() => {
        dispatch(setCurrentOfferPage(Pages.Company));
        dispatch(setProgressBarCurrentStep(stepNames.companyDetails));
        if (offerFlow === 'ioss')
            dispatch(setAdditionalRequiredFields([emeaCompanyField]));
    }, []);
    const { formattedCountries, formattedRegions } = useFetchRegionsAndCountries(shouldFetchRegionsAndCountries);
    const emeaCompanyTypes = [
        { value: 'Business' },
        { value: 'Sole Trader' },
    ];
    const handleClick = () => {
        if (offerFlow) {
            dispatch(goToNextOfferStep({ history }));
        }
        else if (flow) {
            history.push({ pathname: `/${flow}/payment`, search: window.location.search });
        }
    };
    return (React.createElement(FormContainer, { isEmbedded: isEmbedded },
        React.createElement("h1", null, "Tell us more about your company"),
        allowedUsers !== 'NEW' && React.createElement(SignInLink, null),
        React.createElement("form", { "aria-label": 'form for company details' },
            offerFlow === 'ioss' &&
                React.createElement(SRow, null,
                    React.createElement(SCol, { span: '6', className: 'pad-right-sm pad-top-sm pad-bottom-sm' },
                        React.createElement("label", { htmlFor: 'company-type' }, "Company type"),
                        React.createElement(FormSelect, { fieldName: emeaCompanyField, fieldValues: emeaCompanyTypes, validateDuringInput: true, addPadding: true }))),
            React.createElement(SRow, null,
                React.createElement(SCol, { span: '6', className: 'pad-right-sm' },
                    React.createElement("label", { htmlFor: 'street1' }, "Primary business address"),
                    React.createElement(FormInput, { fieldName: 'street1', addPadding: true })),
                React.createElement(SCol, { span: '6' },
                    React.createElement("label", { htmlFor: 'phone' }, "Business phone"),
                    React.createElement(FormInput, { fieldName: 'phone', addPadding: true }))),
            React.createElement(SRow, null,
                React.createElement(SCol, { span: 'md-4 6', className: 'pad-right-sm' },
                    React.createElement("label", { htmlFor: 'city' }, "City"),
                    React.createElement(FormInput, { fieldName: 'city', addPadding: true })),
                React.createElement(SCol, { span: '4' },
                    React.createElement("fieldset", { style: { width: '95%' } },
                        React.createElement("label", { htmlFor: 'state' }, "Region"),
                        React.createElement(FormSelect, { fieldName: 'state', fieldValues: formattedRegions }))),
                React.createElement(SCol, { span: 'md-4 2' },
                    React.createElement("label", { htmlFor: 'postalCode' }, "Postal code"),
                    React.createElement(FormInput, { fieldName: 'postalCode', addPadding: true }))),
            React.createElement(SRow, null,
                React.createElement(SCol, { span: '6' },
                    React.createElement("fieldset", { style: { width: '95%' } },
                        React.createElement("label", { htmlFor: 'country' }, "Country"),
                        React.createElement(FormSelect, { fieldName: 'country', fieldValues: formattedCountries }))),
                offerFlow === 'ioss' &&
                    React.createElement(SCol, { span: '6' },
                        React.createElement("label", { htmlFor: 'vat-registration-number' }, "VAT registration number (optional)"),
                        React.createElement("div", { className: 'fs-exclude' },
                            " ",
                            React.createElement(FormInput, { fieldName: 'vatNumber', addPadding: true }))))),
        React.createElement("hr", { className: 'margin-top-xs' }),
        React.createElement("span", { className: 'inline-flex align-items-center margin-top-lg' },
            React.createElement("button", { className: 'primary icon-trailing', "data-ref": 'offer.company-button', disabled: disabled, onClick: handleClick }, "Next"))));
};
export default Company;
